<script>
  export let name;
</script>

<header>
  <h1>{name}</h1>
  <p class="subtitle">Inspiroidu menneestä</p>
</header>

<style>
  header {
    text-align: center;
  }

  h1 {
    color: #080808;
    text-transform: uppercase;
    font-family: Garamond, 'Times New Roman', Times, serif;
    font-size: 4rem;
    font-weight: 100;
    margin-bottom: 1rem;
  }
  .subtitle {
    margin-bottom: 2rem;
    font-style: italic;
  }
</style>
